export const SPACING_SCALING_FACTOR = 8;
export const MOBILE_APP_SMART_BANNER_HEIGHT = '60px';
export const NAVBAR_HEIGHT = '64px';
